import { useEffect } from 'react'
import { useGetUserDepartments } from 'lib/apollo/hooks'
import { captureWarning } from 'lib/monitoring'
import { useEnterpriseStore } from 'store/enterprise'

export const useEnterpriseData = (isAuthenticated: boolean) => {
  const {
    setDepartments,
    setLoading,
    setError,
    clearDepartments,
    setSelectedDepartment,
    selectedDepartment,
    departments,
  } = useEnterpriseStore()

  const {
    data: userDepartmentsQuery,
    loading,
    error,
  } = useGetUserDepartments(isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated) {
      clearDepartments()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    const departments = userDepartmentsQuery?.getUserDepartments?.departments
    const selectedDepartment =
      userDepartmentsQuery?.getUserDepartments?.selectedDepartment
    if (departments) {
      setDepartments(departments)
      if (selectedDepartment) {
        setSelectedDepartment(selectedDepartment)
      } else if (departments.length === 1) {
        setSelectedDepartment(departments[0])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDepartmentsQuery])

  useEffect(() => {
    if (error) {
      const err =
        error instanceof Error
          ? error
          : new Error('Failed to fetch user departments')
      captureWarning(err)
      setError(err.message)
    } else {
      setError(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return {
    loading,
    error,
    departments,
    selectedDepartment,
  }
}
